import React from "react";
import "../../assets/css/article/Articles.css";

const ArticleAucunResultat = () => {
  return (
    <div className="noResultCard">
      <div className="noResultIcon" aria-hidden="true">
        <svg viewBox="0 0 24 24" fill="none">
          <path
            d="M10.5 18.5h3"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinecap="round"
          />
          <path
            d="M12 3.5c-4.7 0-8.5 3.8-8.5 8.5 0 3.1 1.7 5.9 4.3 7.4.3.2.5.6.5 1v.7c0 .6.5 1.1 1.1 1.1h5.2c.6 0 1.1-.5 1.1-1.1v-.7c0-.4.2-.8.5-1 2.6-1.5 4.3-4.3 4.3-7.4 0-4.7-3.8-8.5-8.5-8.5Z"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinejoin="round"
          />
        </svg>
      </div>

      {/* <h3 className="noResultTitle">Aucun article disponible pour le moment</h3>
      <p className="noResultText">
        Aucun élément n’est disponible actuellement 🙂. Merci de réessayer ultérieurement.
      </p> */}
      {/* Ajouter un text de chargement */}
      <h3 className="noResultTitle">Chargement des articles...</h3>
      <p className="noResultText">
        Veuillez patienter pendant que nous récupérons les articles disponibles.
      </p>
    </div>
  );
};
export default ArticleAucunResultat;
